import { NgModule } from '@angular/core';
import { BreadcrumbComponent } from './breadcrumb.component';
import { CommonModule } from "@angular/common";
import {RouterLink} from "@angular/router";
@NgModule({
    declarations: [
        BreadcrumbComponent,
    ],
    exports: [
        BreadcrumbComponent,
    ],
    imports: [
        CommonModule,
        RouterLink,
    ]
})
export class BreadcrumbModule { }